import UpgradeContainer from './upgrade_container';

const Upgrade = UpgradeContainer;
export default Upgrade;
